function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom";
import "yet-another-react-lightbox/dist/styles.css";
import ReactPlayer from "react-player";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ProjectConsUpdateNew(_ref) {
  var constructionGallery = _ref.constructionGallery,
    constructionProgress = _ref.constructionProgress,
    isDuville = _ref.isDuville,
    config = _ref.config;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var pImages = constructionGallery === null || constructionGallery === void 0 ? void 0 : constructionGallery.map(function (image) {
    return image.url;
  });

  // console.log('construction', constructionGallery);
  if ((pImages === null || pImages === void 0 ? void 0 : pImages.length) <= 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: " pt-5 flex flex-col",
    children: [/*#__PURE__*/_jsx("h4", {
      className: "z-10 text-xl mt-4 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " font-bold ").concat(config.fontTitle),
      children: "Construction Update"
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "z-10 ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-black" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white"), " grid grid-cols-2 md:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 auto-rows-fr w-full gap-2"),
        children: [constructionProgress > 0 && !isDuville && /*#__PURE__*/_jsx("div", {
          className: "".concat(config !== null && config !== void 0 && config.darkMode ? "bg-black" : "bg-gray-100", " col-span-1 row-span-1 md:col-span-2 md:row-span-2  flex-none mr-2 h-full"),
          children: /*#__PURE__*/_jsx("div", {
            // className="mt-4"
            style: {
              display: "flex",
              justifyContent: "center",
              alignSelf: "center"
            },
            children: /*#__PURE__*/_jsx(CircularProgressbarWithChildren, {
              styles: {
                path: {
                  stroke: config === null || config === void 0 ? void 0 : config.primaryColor
                }
              },
              strokeWidth: 4,
              className: "w-28 h-28 md:w-60 md:h-60 p-2 md:p-4",
              value: constructionProgress,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  fontSize: 24,
                  textAlign: "center"
                },
                children: /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsxs("strong", {
                    className: "text-[20px] md:text-[24px]",
                    children: [constructionProgress, "%"]
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
                    className: "text-[14px] md:text-[24px] ".concat(config.fontBody),
                    children: "Completed"
                  })]
                })
              })
            })
          })
        }), constructionGallery.slice(0, 14).map(function (image, i) {
          if (image.urlType == "IMAGE") {
            return /*#__PURE__*/_jsx("img", {
              onClick: function onClick() {
                return setIndex(i);
              },
              className: "z-10 h-[120px] w-[250px] cursor-pointer object-cover ",
              src: image.url
            });
          }
          if (image.urlType == "VIDEO") {
            return /*#__PURE__*/_jsxs("div", {
              onClick: function onClick() {
                return window.open(image.url, "_blank");
              },
              className: "".concat(i == 0 ? "md:row-span-2 md:col-span-2 md:h-full" : "row-span-1 md:h-[120px] xl:h-[120px] ", " relative object-cover w-full cursor-pointer"),
              children: [/*#__PURE__*/_jsx("div", {
                className: "absolute inset-0 z-20"
              }), /*#__PURE__*/_jsx(ReactPlayer, {
                height: "100%",
                width: "100%",
                url: image.url,
                controls: true
              })]
            });
          }
        })]
      })
    }), constructionGallery.length > 14 && /*#__PURE__*/_jsxs("button", {
      onClick: function onClick() {
        return setIndex(18);
      },
      className: "".concat(config.fontBody, " float-right mt-1 z-10 bg-gray-100 py-1 px-2 font-medium cursor-pointer"),
      children: ["+ ", constructionGallery.length - 14 + " more images"]
    }), /*#__PURE__*/_jsx(Lightbox, {
      slides: pImages.map(function (image) {
        return {
          src: image,
          height: null,
          width: null
        };
      }),
      open: index >= 0,
      index: index,
      close: function close() {
        return setIndex(-1);
      },
      plugins: [Fullscreen, Zoom]
    })]
  });
}